export type TokenChecker<T extends string> = (token: T) => boolean;

/*                                                                                                                */
/*                                                                                                                   */
/*                                  */
export function getTokenChecker<T extends string>(tokens: string): TokenChecker<T> {
  const tokensArray = tokens.split(" ").map((token) => token.trim().toLowerCase());
  return (token: T): boolean => {
    return tokensArray.includes(String(token).toLowerCase());
  };
}
